import emma from '@/common/services/Emma'

const OfficeResource = {
	createOffice (data) { return emma.post('api/office', data) },
	updateOfficeTheme (id, data) { return emma.post(`api/office/${id}/theme`, data) },
	updateOfficeHosts (id, data) { return emma.post(`api/office/${id}/hosts`, data) },
	updateOffice (id, data) { return emma.post(`api/office/${id}`, data) },
	updateOfficeLogo (id, data) { return emma.post(`api/office/${id}/logo`, data) }
}

export default OfficeResource



// WEBPACK FOOTER //
// ./src/common/resources/Office.js